import moment from "moment"

// Parsing robusto de datas da API: evita que fevereiro e outros meses quebrem por formato ou timezone
function parseLabelToTimestamp(label) {
    if (label == null) return NaN
    if (typeof label === "number" && !Number.isNaN(label)) return label
    const s = String(label).trim()
    if (!s) return NaN
    // ISO e formatos numéricos (local)
    const formats = ["YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm:ss.SSS", "DD/MM/YYYY", "DD-MM-YYYY", "MM/DD/YYYY"]
    let m = moment(s, formats, true)
    if (!m.isValid()) m = moment(s)
    return m.isValid() ? m.valueOf() : NaN
}

export const mapFetchDashboardDataRequest = ({ initialDate, finalDate, storeId }) => {
    const request = {
        "datainicio": initialDate,
        "datafinal": finalDate,
    }

    return storeId ? { ...request, "EstabelecimentoId": storeId } : request;
}

export const mapFetchSimpleInfoResponse = (response) => {
    return response.map(res => ({
        label: res.Label,
        data: res.Data,
        tag: res.Tag
    }))
}

export const mapFetchBarChartResponse = (response) => {
    if (!response) return { labels: [], datasets: [] };
    const labels = Array.isArray(response.Label) ? response.Label : [];
    const rawDatasets = Array.isArray(response.Datasets) ? response.Datasets : [];
    const datasets = rawDatasets.filter(Boolean).map(dt => ({
        data: Array.isArray(dt.Data) ? dt.Data.map(d => Number(d)) : [],
        label: dt.Label,
        name: dt.Name ?? dt.Label
    }));
    return { labels, datasets };
}
 
export const mapFetchDailyHistoryChartResponse = (response) => {
    if (!response) return { labels: [], datasets: [] };
    const rawLabels = Array.isArray(response.Label) ? response.Label : [];
    const labels = rawLabels.map((label) => parseLabelToTimestamp(label));
    const d0 = response.Datasets?.[0];
    if (!d0) return { labels, datasets: [] };
    const datasets = [
        {
            data: Array.isArray(d0.DataFaturamento) ? d0.DataFaturamento : [],
            label: d0.LabelFaturamento ?? '',
            name: d0.LabelFaturamento,
            type: 'line'
        },
        {
            data: Array.isArray(d0.Data) ? d0.Data : [],
            label: d0.Label ?? '',
            name: d0.Label,
            type: 'column'
        }
    ];
    return { labels, datasets };
}

export const mapFetchPieChartResponse = (response) => {
    if (!response) return { labels: [], dataset: [] };
    const labels = Array.isArray(response.Label) ? response.Label : [];
    const dataset = Array.isArray(response.Dataset) ? response.Dataset.map(d => Number(d)) : [];
    return { labels, dataset };
}


export const mapFetchHeatMapResponse = (response) => {
    if (!Array.isArray(response)) return [];
    return response.filter(Boolean).map(row => ({
        label: row.Label ?? '',
        data: Array.isArray(row.Data) ? row.Data.map(d => ({
            x: `${d?.X ?? ''}hr`,
            y: d?.Y ?? ''
        })) : []
    }));
}

export const mapFetchReviews = (response) => {
    return {
        score: response.NotaMedia.Data,
        comments: response.Comentarios.Data.map(comment => ({
            name: comment.Nome,
            score: comment.Nota,
            text: comment.Comentario,
            date: comment.DataAvaliado
        }))
    }
}

export const mapFetchProductsRanking = (response) => {
    return response.Produtos.Data.map((product, i) => ({
        ranking: i + 1,
        name: product.ProdutoNome,
        quantity: product.TotalQuantidade,
        value: product.TotalValor
    }))
}

export const mapFetchClientsRanking = (response) => {
    return response.Usuarios.Data.map((client, i) => ({
        ranking: i + 1,
        name: client.NomeUsuario,
        period: client.Periodo,
        always: client.Sempre
    }))
}